/**
 * The canonical check for the WordPress partner account.
 * The literal 'wordpress' MUST only appear in this file at runtime —
 * call this helper everywhere else so the upcoming rename to
 * 'mariawittmann_com' touches one place.
 */
export function isWordPressPartner(partnerType: string | null | undefined): boolean {
  return partnerType === 'wordpress';
}

/**
 * The canonical check for a file-import partner account (the backend's
 * `isFileImportPartner` in `src/lib/partner-type.ts` holds the same code).
 * Image removal is offered for these accounts only.
 */
export function isFileImportPartner(partnerType: string | null | undefined): boolean {
  return partnerType === 'file_import';
}
